import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, Button, CircularProgress } from '@mui/material'
import theme from 'ui/theme'
import { useTranslation } from 'react-i18next'
import { Text1 } from 'ui/shorthands/Texts'

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    padding: theme.spacing(3),
    maxWidth: 488,
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  caption: {
    color: theme.palette.text.primary,
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    minWidth: 320,
  },
}))

export const FormToSmartOneHealth: React.FC<{
  url: string
  token: string | null
  isLoading: boolean
  errorMessage: React.ReactNode | null
  handleClose: () => void
}> = ({ url, token, isLoading, errorMessage, handleClose }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  if (isLoading)
    return (
      <Box className={classes.loadingWrapper}>
        <CircularProgress />
      </Box>
    )

  return (
    <Box className={classes.wrapper}>
      <Text1 className={classes.caption}>
        {errorMessage ??
          t('外部サイトを新しいタブで開きます。よろしいですか？')}
      </Text1>
      <Box className={classes.buttons}>
        <Button
          color="primary"
          onClick={(e) => {
            handleClose()
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          {errorMessage ? t('閉じる') : t('キャンセル')}
        </Button>
        {!errorMessage && token && (
          <form
            name="smartOneHealth"
            method="POST"
            action={url}
            target="_blank"
            onSubmit={() => {
              // NOTE: モーダルが閉じる前にformがunmountされてしまうため遅延させる
              setTimeout(() => {
                handleClose()
              }, 10)
            }}
          >
            <input type="hidden" name="token" value={token} />
            <Button color="primary" type="submit">
              {t('OK')}
            </Button>
          </form>
        )}
      </Box>
    </Box>
  )
}
